/** Minimum auto-hide duration for toast-style notifications and transient status messages (ms). */
export const NOTIFICATION_AUTO_HIDE_MS = 10_000;

/** Dataset import modal: auto-close after successful import (ms). */
export const DATASET_IMPORT_MODAL_SUCCESS_AUTO_CLOSE_MS = 2_000;
